import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Integrations } from "@/components/github/integrations";
import { parseOutcomeSearch, type OutcomeSearch } from "@/components/github/logic";
import { parseSlackOutcomeSearch, type SlackOutcomeSearch } from "@/components/slack/logic";
import { SlackIntegration, SlackOutcomeNotice } from "@/components/slack/integration";

export const Route = createFileRoute("/_app/$workspaceSlug/settings/integrations")({
  // `/github/callback` and `/slack/callback` arrive here saying how the trip went.
  validateSearch: (search): OutcomeSearch & SlackOutcomeSearch => ({
    ...parseOutcomeSearch(search),
    ...parseSlackOutcomeSearch(search),
  }),
  component: IntegrationsSettings,
});

function IntegrationsSettings() {
  const { github, reason, slack, slackReason } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  // Out of the address too, so that a reload does not say it again.
  const dismiss = () => void navigate({ search: {}, replace: true });
  return (
    <>
      {/* At the top, where someone back from Slack lands. */}
      <SlackOutcomeNotice outcome={{ slack, slackReason }} onDismiss={dismiss} />
      <Integrations outcome={{ github, reason }} onDismissOutcome={dismiss} />
      <SlackIntegration />
    </>
  );
}
